<div class="lg:flex lg:gap-4 mb-0 lg:mb-4">
  <app-pet-section [(pet)]="pet" class="w-2/3" />
  <app-location-section [petId]="petId()" class="w-1/3" />
</div>
<div class="lg:flex lg:gap-4">
  <app-medical-history-section [petId]="petId()" class="w-1/2" />
  <app-vaccine-history-section [petId]="petId()" class="w-1/2" />
</div>
